<template>
    <div>

        <rkm-area
            title="Transferências enviadas"
            no-margin-top
        >

            <rkm-table
                :fields="fields.tables.tipo"
                :items="dados"
                :filter="filter"
                ref="Table"
                class="mt-3"
            >
                <template slot="filters">
                    <rkm-row>
                        <rkm-col class="flex-grow-1">
                            <rkm-form-input
                                placeholder="Digite para buscar"
                                v-model="filter"
                            >
                                <rkm-input-group-prepend slot="prepend">
                                    <rkm-input-group-text>Buscar</rkm-input-group-text>
                                </rkm-input-group-prepend>
                            </rkm-form-input>
                        </rkm-col>

                        <rkm-col class="flex-grow-0">
                            <rkm-button
                                :disabled="!filter"
                                @click="handleClearFilter"
                            >
                                Limpar
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </template>

                <template v-slot:cell(cota)="row" >
                    <span>{{ getCotaExame(row.item) }}</span>
                </template>

                <template v-slot:cell(origemInicio)="row">
                    <span>{{ row.item.origemInicio }} - {{ row.item.origemFim }}</span>
                </template>

                <template v-slot:cell(destinoInicio)="row">
                    <span>{{ row.item.destinoInicio }} - {{ row.item.destinoFim }}</span>
                </template>
            </rkm-table>
        </rkm-area>

        <rkm-area
            title="Transferências recebidas"
        >

            <rkm-table
                :fields="fields.tables.transferencia"
                :items="dadosRecebidos"
                :filter="filter"
                ref="Table"
                class="mt-3"
            >
                <template slot="filters">
                    <rkm-row>
                        <rkm-col class="flex-grow-1">
                            <rkm-form-input
                                placeholder="Digite para buscar"
                                v-model="filter"
                            >
                                <rkm-input-group-prepend slot="prepend">
                                    <rkm-input-group-text>Buscar</rkm-input-group-text>
                                </rkm-input-group-prepend>
                            </rkm-form-input>
                        </rkm-col>

                        <rkm-col class="flex-grow-0">
                            <rkm-button
                                :disabled="!filter"
                                @click="handleClearFilter"
                            >
                                Limpar
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </template>

                <template v-slot:cell(origemUnidadeId)="row">
                    <span>{{ getNomeOrigem(row.item.origemUnidadeId) }}</span>
                </template>

                <template v-slot:cell(origemInfraestruturaId)="row">
                    <span>{{ geInfraestruturaOrigem(row.item.origemUnidadeId, row.item.origemInfraestruturaId) }}</span>
                </template>

                <template v-slot:cell(cota)="row" >
                    <span>{{ getCotaExame(row.item) }}</span>
                </template>

                <template v-slot:cell(origemInicio)="row">
                    <span>{{ row.item.origemInicio }} - {{ row.item.origemFim }}</span>
                </template>

                <template v-slot:cell(destinoInicio)="row">
                    <span>{{ row.item.destinoInicio }} - {{ row.item.destinoFim }}</span>
                </template>
            </rkm-table>
        </rkm-area>

    </div>
</template>

<script>
// Mixins.
import { data, formats } from '@/mixins'

// Moment.
import moment from 'moment'

// Enums.
import tipoCota from '@/enums/exame-laboratorial/tipoCota'
import tipoUnidade from '@/enums/exame-laboratorial/tipoUnidade'

export default {
    computed: {
        fields() {

            return {
                tables: {
                    tipo: [
                        {
                            key: 'destinoNomeFantasia',
                            label: 'Unidade destino',
                            sortable: true
                        },
                        {
                            key: 'destinoInfraestruturaNome',
                            label: 'Local de atendimento',
                            sortable: true
                        },
                        {
                            key: 'origemCotaTipoNome',
                            label: 'Tipo',
                            sortable: true
                        },
                        {
                            key: 'cota',
                            label: 'Cota',
                            sortable: true
                        },
                        {
                            key: 'origemInicio',
                            label: 'Período origem',
                            sortable: true
                        },
                        {
                            key: 'destinoInicio',
                            label: 'Período destino',
                            sortable: true
                        },
                    ],
                    transferencia: [
                        {
                            key: 'origemUnidadeId',
                            label: 'Unidade origem',
                            sortable: true
                        },
                        {
                            key: 'origemInfraestruturaId',
                            label: 'Local de atendimento',
                            sortable: true
                        },
                        {
                            key: 'origemCotaTipoNome',
                            label: 'Tipo',
                            sortable: true
                        },
                        {
                            key: 'cota',
                            label: 'Cota',
                            sortable: true
                        },
                        {
                            key: 'origemInicio',
                            label: 'Período origem',
                            sortable: true
                        },
                        {
                            key: 'destinoInicio',
                            label: 'Período destino',
                            sortable: true
                        },
                    ],
                }
            }
        },
        dados(){

            return this.cotaUnidadeSolicitante.filter(i => {return i.origemCotaTipoId == this.cota.tipoId
                && moment(
                    this.getFormatedDate(this.cota.periodo.start, 'YYYY-MM-DD')
                )
                .isBetween(
                    i.origemInicio.split("/").reverse().join("-"),
                    i.origemFim.split("/").reverse().join("-"),
                    null,
                    '[]'
                )

                || i.origemCotaTipoId == this.cota.tipoId
                    && moment(
                        this.getFormatedDate(this.cota.periodo.end, 'YYYY-MM-DD')
                    )
                    .isBetween(
                        i.origemInicio.split("/").reverse().join("-"),
                        i.origemFim.split("/").reverse().join("-"),
                        null,
                        '[]'
                    )
            })
        },
        dadosRecebidos(){

            let transferenciaLaboratorio = this.data.model.cotasTransferencia.filter(field =>
                field.unidadeTipoId == this.enums.tipoUnidade.UNIDADE_SOLICITANTE)

                if (transferenciaLaboratorio.length > 0) {

                    transferenciaLaboratorio = transferenciaLaboratorio.map(field2 => field2.destino)

                    Object.keys(transferenciaLaboratorio).forEach(a => {

                        let recebidos = transferenciaLaboratorio[a]
                            .filter(i => i.destinoUnidadeId == this.unidadeId
                                && i.destinoInfraestruturaId == this.infraestruturaId
                                && i.origemCotaTipoId == this.cota.tipoId
                                && moment(
                                    this.getFormatedDate(this.cota.periodo.start, 'YYYY-MM-DD')
                                )
                                .isBetween(
                                    i.destinoInicio.split("/").reverse().join("-"),
                                    i.destinoFim.split("/").reverse().join("-"),
                                    null,
                                    '[]'
                                )

                                || i.destinoUnidadeId == this.unidadeId
                                    && i.destinoInfraestruturaId == this.infraestruturaId
                                    && i.origemCotaTipoId == this.cota.tipoId
                                    && moment(
                                        this.getFormatedDate(this.cota.periodo.end, 'YYYY-MM-DD')
                                    )
                                    .isBetween(
                                        i.destinoInicio.split("/").reverse().join("-"),
                                        i.destinoFim.split("/").reverse().join("-"),
                                        null,
                                        '[]'
                                    )
                            )

                        recebidos.forEach(v => {

                            this.recebidos.push(v)
                        });
                    })
                }

            return this.recebidos
        },
    },
    data: () => ({
        items: [],
        recebidos: [],
        filter: null,
        enums: {
            tipoCota,
            tipoUnidade,
        },
    }),
    methods: {
        handleClearFilter() {
            this.filter = null
        },
        getCotaExame(item) {

            let cotaExame = 0

            if (item.origemCotaTipoId == this.enums.tipoCota.VALOR) {

                 cotaExame = item.exames.reduce((sum, element) => {

                    if (element.transferido) {
                        sum = sum + this.formatSumMoney(element.transferido);
                    }

                    return sum;
                },0)

                if (cotaExame) {

                    cotaExame = this.formatMoney(cotaExame, 2)

                    let destinoCotaValor = this.formatMoney(item.destinoCotaValor, 2)
                    let cotaTotal = this.formatSumMoney(destinoCotaValor) + this.formatSumMoney(cotaExame)

                    return this.formatMoney(cotaTotal, 2)

                } else {

                    return this.formatMoney( item.destinoCotaValor, 2)
                }

            } else {

                cotaExame = item.exames.reduce((sum, element) => {

                    if (element.transferido) {
                        sum = sum + Number(element.transferido);
                    }

                    return sum;
                },0)

                return this.formatMoney(Number(item.destinoCotaQuantidade) + cotaExame, 0)
            }
        },
        getNomeOrigem(unidadeId){

            const unidade = this.data.form.unidades.find(u => u.id == unidadeId)

            return unidade.nomeFantasia
        },
        geInfraestruturaOrigem(unidadeId, infraestruturaId){

            const unidade = this.data.form.unidades.find(u => u.id == unidadeId)
            const infraestrutura = unidade.infraestruturas.find(u => u.id == infraestruturaId)

            return infraestrutura.nome
        }
    },
    mixins: [data, formats],
    props: {
        unidadeId: { type: Number, default: null },
        infraestruturaId: { type: Number, default: null },
        laboratorioUnidadeId: { type: Number, default: null },
        laboratorioInfraestruturaId: { type: Number, default: null },
        data: { type: Object, required: true },
        cotaUnidadeSolicitante: { type: Array, required: true },
        cota: { type: Object, required: true },
    },
}
</script>

<style scoped>
.colorButton {
    color: #fff;
}
</style>